import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs/internal/Observable";
import {Place} from "./place";
import {map} from "rxjs/internal/operators";
import {connectApi} from "../connect-api";

export const addressSource = 'CANADA_POST';

@Injectable({
    providedIn: 'root'
})
export class AddressSearchService {

    constructor(private httpClient: HttpClient) {
    }


    //Gets address suggestions based on input string
    searchPlaces(input: string, countryCode: string): Observable<Place[]> {
        let url = connectApi.searchPlaces
            .replace('{addressSource}', addressSource)
            .replace('{countryCode}', countryCode)
            .replace('{input}', encodeURIComponent(input));

        return this.httpClient
            .get(url)
            .pipe(map((res: Response) => {
                let result: Place[] = [];
                if (res['Places']) {
                    result = res['Places'].map(item => {return new Place(item)});
                }
                if(result.length == 0){
                    let place : Place = new Place();
                    place.description = 'No records available';
                    result.push(place);
                }
                return result;
            }));

    }

    //Gets address suggestions based on last Id
    searchPlacesById(lastId: string): Observable<Place[]> {
        let url: string = connectApi.searchPlacesById.replace('{lastId}', lastId);
        return this.httpClient.get(url)
            .pipe(map((res: Response) => {
                if (res['Places']) {
                    return res['Places'].map(item => {return new Place(item)});
                }
            }));
    }

    //Gets detail info of the place selected from auto-complete
    getPlaceDetail(place: Place): Observable<Place> {
        let encodedPlaceId : string = encodeURIComponent(place.placeId);
        let url: string = connectApi.searchPlacesByIdAndSource.replace('{lastId}', encodedPlaceId).replace('{source}', place.source);
        return this.httpClient.get(url)
            .pipe(map((res: Response) => {
                if (res['Place']) {
                    return new Place(res['Place']);
                }
            }));
    }


}